export default __webpack_public_path__ + "images/pattern-2.34cf043a54af62c5b33e734b865c4d18.svg";